import { render } from "./MindMapImgEditor.vue?vue&type=template&id=1fa4773e"
import script from "./MindMapImgEditor.vue?vue&type=script&lang=js"
export * from "./MindMapImgEditor.vue?vue&type=script&lang=js"

import "./MindMapImgEditor.vue?vue&type=style&index=0&id=1fa4773e&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__